export const CARD_IMAGE_FIELD_GROUPS = {
  CHARACTER_MAIN: "characterMain",
  CHARACTER_BACKGROUND: "characterBackground",
  INFINITY: "infinity",
};

export const CARD_IMAGE_FIELDS = {
  CHARACTER_MAIN: ["imageUrl", "imageStart", "imageFin", "imageHit"],
  CHARACTER_BACKGROUND: ["imageBG"],
  INFINITY: ["imageUrl"],
};

const normalizeVersionNumber = (version) => {
  const raw = String(version ?? "").trim();
  if (!raw) return 1;

  const parsed = Number.parseInt(raw, 10);
  if (!Number.isFinite(parsed) || parsed <= 1) return 1;
  return parsed;
};

export const getCharacterImageStorageFolder = ({
  version,
  field,
  background = false,
} = {}) => {
  const versionNumber = normalizeVersionNumber(version);
  const isBackground = background || field === "imageBG";
  const baseFolder =
    versionNumber <= 1 ? "NFT Images" : `NFT Images/Version ${versionNumber}`;

  if (!isBackground) return baseFolder;
  return versionNumber <= 1
    ? `${baseFolder}/backgrounds`
    : `${baseFolder}/Backgrounds`;
};

export const getInfinityImageStorageFolder = () => "Infinity Card Images";

export const getCardImageStorageFolder = ({
  cardType,
  version,
  field,
} = {}) => {
  if (cardType === "infinity") return getInfinityImageStorageFolder();
  return getCharacterImageStorageFolder({ version, field });
};

export const getCardImageFieldGroup = ({ cardType, field } = {}) => {
  if (cardType === "infinity") return CARD_IMAGE_FIELD_GROUPS.INFINITY;
  if (field === "imageBG") return CARD_IMAGE_FIELD_GROUPS.CHARACTER_BACKGROUND;
  return CARD_IMAGE_FIELD_GROUPS.CHARACTER_MAIN;
};
